import { useCallback } from 'react'
import '../css/Works.css'
import WorkCard from './WorkCard'

const Works = ({ appState, setState }) => {
  const openModal = useCallback(
    (e, work) => {
      if (e?.preventDefault) e.preventDefault()
      setState(state => ({
        ...state,
        modal: { isOpen: !state.modal.isOpen },
        work: { items: [...state.work.items], selected: work },
      }))
    },
    [setState],
  )
  return (
    <section>
      <div className='container' id='works'>
        {appState.work.items.map(work => (
          <WorkCard key={work.id} {...{ openModal, work }} />
        ))}
      </div>
    </section>
  )
}

export default Works
